module.exports = __webpack_public_path__ + "media/images/icons/curriculum-378945075453bb03890b4e4343c2286b.svg";